module.exports = __webpack_public_path__ + "img/previewImg2.80f17668.png";